import type { FC } from 'react';
import { Link } from 'react-router-dom';

import { AvatarButton, Initials } from './styled';

import { Sizes } from '../../constants/sizes';
import type { IUserProfile } from '../../types/user';

export interface IAvatar {
    isDisabled?: boolean;
    profileUrl?: string;
    user: IUserProfile | null;
}

export const Avatar: FC<IAvatar> = ({ isDisabled, profileUrl, user }) => {
    const { firstName, lastName } = user ?? {};
    const initials = `${firstName?.charAt(0)}${lastName?.charAt(0)}`;

    return (
        <AvatarButton
            as={isDisabled ? 'div' : Link}
            {...(isDisabled ? {} : { to: profileUrl ?? '' })}
            isDisabled={Boolean(isDisabled)}
        >
            <Initials size={Sizes.XL}>{initials}</Initials>
        </AvatarButton>
    );
};

Avatar.defaultProps = {
    isDisabled: false,
    profileUrl: undefined,
};
